module.exports = __webpack_public_path__ + "static/media/annaluke_engagement-47-min.7274eb86.jpg";